<template>
    <div class="main-content main-content-cinema">
        <div class="container-fluid container-cinema">
            <div class="row">
                <div class="col-12">
                    <p class="cinema-title"><strong>Cinema</strong></p>
                </div>
            </div>
        </div>

        <div class="container container-banner">
            <div class="row">
                <div class="col-12">
                    <div id='div-gpt-ad-1603501550614-0'></div>
                </div>
            </div>
        </div>

        <div class="container container-cinema-content">
            <div class="row">
                <div class="col-12" v-if="destaque">
                    <div class="main-cinema-featured">
                        <img :src="utils.image(destaque.fundo, 1120,452)" alt="">
                        <div class="main-cinema-infos">
                            <p class="main-cinema-genre"><strong>{{destaque.generos}}</strong></p>
                            <h1 class="main-cinema-movie-title">{{destaque.titulo}}</h1>
                            <p class="main-cinema-synopsis">
                                {{destaque.sinopse.substring(0,100)}}...
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="section-title">
                    <p>Em cartaz</p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6 col-md-3" v-for="(filme, key) in filmes" :key="key">
                    <div class="movie-item">
                        <router-link :to="'/cinema/'+filme.slug">
                            <img :src="utils.image(filme.poster, 256, 384)" alt="">
                        </router-link>
                        <p class="movie-title"><strong>{{filme.titulo}}</strong></p>
                        <p class="movie-genre">{{filme.generos}}</p>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
import movie from '@/store/movie'
import utils from '@/utils'

export default {
    name: 'Index',
    head: {
        title:{
            inner: 'Cinema'
        }
    },
    data() {
        return {
            filmes: null,
            destaque: null,
            utils: utils,
        }
    },
    methods: {
        async getFilmes(){
            await movie.dispatch('getMovies')
            this.filmes = Object.assign({}, movie.getters.all)
            const key = Object.keys(this.filmes)[0]
            this.destaque = this.filmes[key]
            delete this.filmes[key]
        },
    },
    mounted() {
        this.getFilmes()

        var googletag = window.googletag
        googletag.cmd.push(function() {
            googletag.destroySlots()
            googletag.defineSlot('/1513505/v1_gweb_superbanner_topo', [[970,250], [300, 100], [728, 90]], 'div-gpt-ad-1603501550614-0').addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices();
            googletag.display('div-gpt-ad-1603501550614-0');
        })
    }
}
</script>